const translations = {
    de: {
        noCountryFound: 'Kein Land gefunden',
        validation: {
            Required: 'Dies ist ein Pflichtfeld',
            EmptyText: 'Bitte geben Sie einen gültigen Text ein',
            InvalidNumber: 'Bitte geben Sie eine gültige Nummer ein',
            InvalidPhone: 'Bitte geben Sie eine gültige Telefonnummer ein',
            PhoneTooLong: 'Diese Telefonnummer sieht zu lang aus',
            PhoneTooShort: 'Diese Telefonnummer sieht zu kurz aus',
            InvalidEmail: 'Bitte geben Sie eine gültige E-Mail-Adresse ein',
            InvalidUrl: 'Bitte geben Sie eine gültige URL ein',
            InvalidBirthday: 'Bitte geben Sie ein gültiges Geburtsdatum ein',
            InvalidFile: 'Bitte probieren Sie ein anderes Dateiformat',
            FileTooLarge: 'Bitte probieren Sie es mit einer kleineren Datei',
        },
    },
    en: {
        noCountryFound: 'No country found',
        validation: {
            Required: 'This is a required field',
            EmptyText: 'Please enter a valid text',
            InvalidNumber: 'Please enter a valid number',
            InvalidPhone: 'Please enter a valid phone',
            PhoneTooLong: 'This phone number looks too long',
            PhoneTooShort: 'This phone number looks too short',
            InvalidEmail: 'Please enter a valid email',
            InvalidUrl: 'Please enter a valid URL',
            InvalidBirthday: 'Please enter a valid birthday',
            InvalidFile: 'Please try a different file format',
            FileTooLarge: 'Please try with a smaller file',
        },
    },
};

export default translations;
